const SLICE_WIDTH_MMT_BY_PAGE_RANGE: {
  [format: string]: { min: number; max: number; width: number; top: number }[];
} = {
  RIGA4POR: [
    { min: 0, max: 33, width: 6, top: -85 },
    { min: 34, max: 57, width: 8, top: -70 },
    { min: 58, max: 81, width: 10, top: -60 },
    { min: 82, max: 200, width: 12, top: -50 },
  ],
  RIGCAR21: [
    { min: 0, max: 33, width: 6, top: -80 },
    { min: 34, max: 57, width: 8, top: -70 },
    { min: 58, max: 81, width: 10, top: -60 },
    { min: 82, max: 200, width: 12, top: -50 },
  ],
  RIGA4PAY: [
    { min: 0, max: 33, width: 6, top: -80 },
    { min: 34, max: 57, width: 8, top: -70 },
    { min: 58, max: 81, width: 10, top: -60 },
    { min: 82, max: 200, width: 12, top: -50 },
  ],
  RIGCAR30: [
    { min: 0, max: 33, width: 6, top: -80 },
    { min: 34, max: 57, width: 8, top: -70 },
    { min: 58, max: 81, width: 10, top: -60 },
    { min: 82, max: 200, width: 12, top: -50 },
  ],
  RIGA5PAY: [
    { min: 0, max: 33, width: 6, top: -80 },
    { min: 34, max: 57, width: 8, top: -70 },
    { min: 58, max: 81, width: 10, top: -60 },
    { min: 82, max: 200, width: 12, top: -50 },
  ],
};


export const getSliceWidthAndTop = (format: string, numberOfPages: number) => {
  const ranges = SLICE_WIDTH_MMT_BY_PAGE_RANGE[format] ?? [];
  for (const range of ranges) {
    if (numberOfPages >= range.min && numberOfPages <= range.max) {
      return {
        widthMM: range.width,
        top: range.top,
      };
    }
  }
  return {
    widthMM: 6,
    top: -65,
  };
};

export const computeTopOffset = (format: string, numberOfPages: number, ratio: number): number => {
  const { top } = getSliceWidthAndTop(format, numberOfPages);
  return top;
};

export const isRigideFormat = (format: string): boolean => {
  return ['RIGA4POR', 'RIGCAR21', 'RIGA4PAY', 'RIGCAR30', 'RIGA5PAY'].includes(format);
}